<template>
  <div class="finishedCheckBillsSummaryDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field
        v-model="form.NuclearAccountNo"
        :label="$t.finishedCheckBillsSummary.nuclearAccountNo"
        readonly
      />
      <van-field
        v-model="form.CreateTime"
        :label="$t.finishedCheckBillsSummary.creditDate"
        readonly
      />
      <van-field
        v-model="form.CompanyNameSn"
        :label="$t.finishedCheckBillsSummary.customerName"
        type="textarea"
        rows="3"
        readonly
      />
      <van-field
        v-model="form.NuclearTypeStr"
        :label="$t.finishedCheckBillsSummary.nuclearType"
        readonly
      />
      <van-field
        v-model="form.AccountNickName"
        :label="$t.finishedCheckBillsSummary.bank"
        readonly
      />

      <div class="title">{{ $t.finishedCheckBillsSummary.nuclearTitle }}</div>

      <div
        class="subTotal"
        v-if="form.ReceivedAmountList && form.ReceivedAmountList.length > 0"
      >
        <div class="subTotal-label">
          {{ $t.finishedCheckBillsSummary.receivableAmount }}
        </div>
        <div
          class="subTotal-item"
          v-for="(item, index) in form.ReceivedAmountList"
          :key="index"
        >
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.TotalAmount }}</div>
        </div>
      </div>

      <div
        class="subTotal"
        v-if="form.CreditBalanceList && form.CreditBalanceList.length > 0"
      >
        <div class="subTotal-label">
          {{ $t.finishedCheckBillsSummary.creditAmount }}
        </div>
        <div
          class="subTotal-item"
          v-for="(item, index) in form.CreditBalanceList"
          :key="index"
        >
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.TotalAmount }}</div>
        </div>
      </div>
    </van-form>

    <van-dialog
      :title="$t.finishedCheckBillsSummary.payReceipt"
      width="90%"
      v-model="dialogVisible"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
    >
      <slot name="default">
        <div class="finishedCheckBillsSummaryDetail-alert">
          <van-form label-width="120px">
            <div class="multi-table" v-if="voucherFileList">
              <div v-for="(item, index) in voucherFileList" :key="index">
                <van-field :label="'No.' + (index + 1)">
                  <template #input>
                    <van-image
                      :src="item.PaymentVoucher && imgUrlFilter(item.PaymentVoucher)"
                      @click="imagePreview(imgUrlFilter(item.PaymentVoucher))"
                      width="50"
                      height="50"
                      fit="contain"
                      style="vertical-align: top"
                      v-if="item.PaymentVoucher"
                    ></van-image>
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <van-button type="info" block @click="handleSheetShow">{{
        $t.meta.menu
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Uploader,
  Picker,
  Popup,
  Stepper,
  ActionSheet,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper)
  .use(ActionSheet);

export default {
  name: "finishedCheckBillsSummaryDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      //付款凭证
      dialogVisible: false,
      voucherFileList: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("finishedCheckBillsSummaryDetail"));
    this.form = data;
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    dialogShow() {
      this.getNuclearAccountPaymentVoucherList().then((success) => {
        if (success) this.dialogVisible = true;
      });
    },
    getNuclearAccountPaymentVoucherList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          NarId: this.form.NarId,
        };
        this.$api.financialManagement
          .getNuclearAccountPaymentVoucherList(param)
          .then((res) => {
            this.voucherFileList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    sheetSelect(e) {
      if (e.className == "1") {
        this.gotoCreditedDetails();
      }
      if (e.className == "2") {
        this.dialogShow();
      }
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [{ name: this.$t.finishedCheckBillsSummary.details, className: "1" }];
      if (this.form.PaymentVoucherCount > 0) {
        actions.push({
          name: this.$t.finishedCheckBillsSummary.payReceipt,
          className: "2",
        });
      }
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    gotoCreditedDetails() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "creditedDetails",
        name: "creditedDetails",
        query: [
          {
            name: "NuclearAccountNo",
            value: this.form.NuclearAccountNo,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.finishedCheckBillsSummaryDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .finishedCheckBillsSummaryDetail-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
    .multi-table {
      .multi-table-header {
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
